// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutRecaptchaStyles } from "@steiner/App/Components/Checkout/CheckoutRecaptcha";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

checkoutRecaptchaStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: stretch;
        width: 100%;
        max-width: 100%;
        padding: 12px;
    `,
};

checkoutRecaptchaStyles.cardWrapper = {
    css: css`
        width: 100%;
        max-width: 656px;
        margin-left: auto;
        margin-right: auto;
        align-self: center;
        border: 1px solid ${color("common.border")};
        overflow: hidden;
        background: ${color("common.white")};
    `,
};

checkoutRecaptchaStyles.header = {
    css: css`
        background:${color("primary")};
        color: ${color("common.white")};
        padding: 12px;
    `,
};

checkoutRecaptchaStyles.headerTitle = {
    variant: "h3",
    css: css`
        margin: 0;
        color: ${color("common.white")};
    `,
};

checkoutRecaptchaStyles.recaptchaWrapper = {
    css: css`
        padding: 12px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
        justify-content: space-between;
    `,
};
